import { ReactNode } from 'react';

interface CardProps {
    children: ReactNode;
    className?: string;
}

export default function Card({ children, className = '' }: CardProps) {
    return (
        <div className={`custom-card ${className}`} data-aos="fade-up">
            {children}
        </div>
    );
}
